var _defs, _path, _path2, _g, _path3, _g2, _g3, _path4, _g4, _g5, _g6, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTdsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 133.86 50.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00d99c;}.cls-2{fill:#001a96;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.43,25.21c0,13.92-11.29,25.21-25.21,25.21S0,39.14,0,25.21,11.29,0,25.21,0s25.21,11.29,25.21,25.21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m37.44,13.3c0-6.12-5.47-11.08-12.22-11.08s-12.22,4.96-12.22,11.08,5.47,11.07,12.22,11.07,12.22-4.96,12.22-11.07"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m69.86,3.8v3.96h-4.97v13.45h-4.28V7.76h-4.97v-3.96h14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m70.92,21.21V3.8h5.85c6.37,0,9.98,3.27,9.98,8.65s-3.79,8.75-9.98,8.75h-5.85Zm4.3-3.74h1.35c3.88,0,5.8-1.55,5.8-5.04s-1.89-4.89-5.75-4.89h-1.4v9.93Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m87.73,20.22l.59-3.88h.17c1.3.96,3.15,1.77,4.92,1.77,1.57,0,2.36-.69,2.36-1.62s-.54-1.5-3.49-2.73c-3.34-1.4-4.55-2.93-4.55-5.48,0-2.8,2.29-4.97,6.29-4.97,1.94,0,3.83.54,5.14,1.25l-.59,3.86h-.15c-1.33-.96-3.02-1.52-4.5-1.52-1.25,0-1.82.57-1.82,1.33,0,.81.37,1.23,3.42,2.56,3.52,1.55,4.65,3.17,4.65,5.46,0,3.12-2.61,5.46-6.61,5.46-2.46,0-4.5-.74-5.83-1.47Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.44,29.78c0-2.78,1.87-4.62,4.45-4.62,1.06,0,2.03.29,2.96.87l-.31,2.08h-.07c-.73-.63-1.54-.96-2.36-.96-1.44,0-2.37,1.03-2.37,2.59s.95,2.62,2.41,2.62c.81,0,1.65-.33,2.37-.96h.07l.3,2.07c-.92.58-1.93.89-2.99.89-2.66,0-4.46-1.83-4.46-4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m70.51,25.4h2.14v8.71h-2.14v-3.46h-3.32v3.46h-2.15v-8.71h2.15v3.38h3.32v-3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m78.74,25.4l3.17,8.65-.05.06h-2.37l-.53-1.6h-3.04l-.52,1.6h-2.34l-.05-.06,3.21-8.65h2.51Zm-2.34,5.61h2.07l-.47-1.44c-.17-.54-.41-1.45-.54-2.26h-.04c-.15.81-.38,1.72-.55,2.28l-.47,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m89.58,33.89l-.09.22h-2.24l-2.15-3.23h-.68v3.23h-2.15v-8.71h3.14c2.19,0,3.31.93,3.31,2.79,0,1.13-.54,1.93-1.52,2.33l2.39,3.37Zm-5.15-6.74v2.14h.85c.98,0,1.39-.36,1.39-1.06,0-.74-.44-1.08-1.39-1.08h-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m89.95,25.4h2.15v8.71h-2.15v-8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m99.74,25.4v1.98h-2.48v6.73h-2.14v-6.73h-2.48v-1.98h7.11Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m103.88,25.4l3.17,8.65-.05.06h-2.37l-.53-1.6h-3.04l-.52,1.6h-2.34l-.05-.06,3.21-8.65h2.51Zm-2.34,5.61h2.07l-.47-1.44c-.17-.54-.41-1.45-.54-2.26h-.04c-.15.81-.38,1.72-.55,2.28l-.47,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m107.41,34.11v-8.71h2.98c2.14,0,3.14.85,3.14,2.27,0,.89-.55,1.61-1.4,1.85v.04c1.14.27,1.78,1,1.78,2.08,0,1.6-1.08,2.47-3.48,2.47h-3.01Zm2.15-5.15h.76c.81,0,1.21-.33,1.21-.98,0-.62-.39-.92-1.27-.92h-.7v1.91Zm0,3.46h.76c1.08,0,1.52-.36,1.52-1.06s-.47-1.04-1.46-1.04h-.82v2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m114.74,25.4h2.15v6.8h3.62l-.23,1.91h-5.53v-8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.27,30.44v1.83h3.5l-.21,1.83h-5.45v-8.71h5.45l.21,1.83h-3.5v1.7h3.12v1.51h-3.12Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.46,39.52v1.77h2.99v1.72h-2.99v3.38h-2.15v-8.71h5.3l.21,1.83h-3.36Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.13,42.04c0-2.67,1.91-4.6,4.65-4.6s4.65,1.93,4.65,4.6-1.92,4.6-4.65,4.6-4.65-1.98-4.65-4.6Zm7.05,0c0-1.55-.96-2.63-2.4-2.63s-2.4,1.08-2.4,2.63.97,2.63,2.4,2.63,2.4-1.13,2.4-2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m72.3,42.65v-4.96h2.14v4.82c0,1.54.49,2.17,1.59,2.17s1.59-.63,1.59-2.18v-4.81h2.15v4.94c0,2.6-1.25,4.01-3.74,4.01s-3.73-1.34-3.73-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m80.99,46.4v-8.71h2.08l2.5,3.25c.42.54.84,1.12,1.39,2.03h.05c-.12-.91-.17-1.67-.17-2.46v-2.82h2.13v8.77h-1.77l-2.77-3.49c-.42-.54-.85-1.12-1.43-2.03h-.04c.12.91.17,1.76.17,2.55v2.92h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m90.27,46.4v-8.71h2.93c3.19,0,4.99,1.64,4.99,4.33s-1.89,4.38-4.99,4.38h-2.93Zm2.15-1.87h.68c1.94,0,2.9-.78,2.9-2.52s-.95-2.45-2.88-2.45h-.7v4.97Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m103.55,37.69l3.17,8.65-.05.06h-2.37l-.53-1.6h-3.04l-.52,1.6h-2.34l-.05-.06,3.21-8.65h2.51Zm-2.34,5.61h2.07l-.47-1.44c-.17-.54-.41-1.45-.54-2.26h-.04c-.15.81-.38,1.72-.55,2.28l-.47,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.28,37.69v1.98h-2.48v6.73h-2.14v-6.73h-2.48v-1.98h7.11Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.81,37.69h2.15v8.71h-2.15v-8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.66,42.04c0-2.67,1.91-4.6,4.65-4.6s4.65,1.93,4.65,4.6-1.92,4.6-4.65,4.6-4.65-1.98-4.65-4.6Zm7.05,0c0-1.55-.96-2.63-2.4-2.63s-2.4,1.08-2.4,2.63.97,2.63,2.4,2.63,2.4-1.13,2.4-2.63Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m125.89,46.4v-8.71h2.08l2.5,3.25c.42.54.84,1.12,1.39,2.03h.05c-.12-.91-.17-1.67-.17-2.46v-2.82h2.13v8.77h-1.77l-2.77-3.49c-.42-.54-.85-1.12-1.43-2.03h-.04c.12.91.17,1.76.17,2.55v2.92h-2.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTdsLogo);
export default __webpack_public_path__ + "static/media/TDS-Logo.6c48b93112bfa9cfdc387c68bfcd7ec3.svg";
export { ForwardRef as ReactComponent };